

export default {
  SET_ITEMS(state, payload) {
    state.subservices = payload
  },

  ADD_ITEM(state, payload) {
    state.subservices.push(payload)
  },

  UPDATE_ITEM(state, payload) {
      const ItemIndex = state.subservices.findIndex((p) => p.id == payload.id)
      Object.assign(state.subservices[ItemIndex], payload)
  },

  REMOVE_ITEM(state, itemId) {
      const ItemIndex = state.subservices.findIndex((p) => p.id == itemId)
      state.subservices.splice(ItemIndex, 1)
  }
}
